function matchHeights() {
  const comparisonBox = document.querySelector(".comparison-table-box");
  if (!comparisonBox) return;

  const cards = comparisonBox.querySelectorAll(".pro-info-card");
  const itemGroups = comparisonBox.querySelectorAll(".pro-info-item");

  // 重置高度
  cards.forEach((card) => (card.style.height = "auto"));

  // 获取所有 pro-info-value 元素，按行分组
  const valueRows = [];
  const firstItem = itemGroups[0];
  if (firstItem) {
    const values = firstItem.querySelectorAll(".pro-info-value");
    values.forEach((_, index) => {
      valueRows[index] = [];
    });
  }

  itemGroups.forEach((item) => {
    const values = item.querySelectorAll(".pro-info-value");
    values.forEach((value, index) => {
      if (valueRows[index]) {
        valueRows[index].push(value);
        value.style.height = "auto";
      }
    });
  });

  // 同步卡片高度
  if (cards.length > 0) {
    const maxCardHeight = Math.max(
      ...Array.from(cards).map((card) => card.offsetHeight),
    );
    cards.forEach((card) => (card.style.height = `${maxCardHeight}px`));
  }

  // 同步每行的 pro-info-value 高度
  valueRows.forEach((row) => {
    if (row && row.length > 0) {
      const maxRowHeight = Math.max(...row.map((value) => value.offsetHeight));
      row.forEach((value) => (value.style.height = `${maxRowHeight}px`));
    }
  });
}

// 页面加载完成后执行
document.addEventListener("DOMContentLoaded", matchHeights);

// 窗口大小变化时重新计算
let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(matchHeights, 100);
});
